<!--<template>-->
<!--  <div class="main-conntainer">-->
<!--    <el-table :data="tableData"-->
<!--              stripe-->
<!--              style="width: 100%">-->
<!--      <el-table-column type="index"-->
<!--                       label="序号"-->
<!--                       header-align="center"-->
<!--                       align="center">-->
<!--      </el-table-column>-->
<!--      <el-table-column prop="name"-->
<!--                       label="姓名"-->
<!--                       width="100">-->
<!--      </el-table-column>-->
<!--      <el-table-column prop="group"-->
<!--                       label="医院">-->
<!--      </el-table-column>-->
<!--      <el-table-column prop="gender"-->
<!--                       label="性别"-->
<!--                       width="80">-->
<!--      </el-table-column>-->
<!--      <el-table-column prop="zhicheng"-->
<!--                       label="职称"-->
<!--                       width="120">-->
<!--      </el-table-column>-->
<!--      <el-table-column prop="zhiwu"-->
<!--                       label="职务"-->
<!--                       width="120">-->
<!--      </el-table-column>-->
<!--      <el-table-column prop="role"-->
<!--                       label="角色"-->
<!--                       width="180">-->
<!--      </el-table-column>-->
<!--      <el-table-column prop="status"-->
<!--                       label="状态"-->
<!--                       width="120">-->
<!--        <template slot-scope="scope">-->
<!--          <el-tag :type="scope.row.status === '已通过' ? 'success' : 'danger'"-->
<!--                  disable-transitions>{{scope.row.status}}</el-tag>-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column fixed="right"-->
<!--                       label="操作"-->
<!--                       width="180">-->
<!--        <template slot-scope="scope">-->
<!--          <el-button @click="handleClick(scope.row, '已通过')"-->
<!--                     type="success"-->
<!--                     size="small">通过</el-button>-->
<!--          <el-button @click="handleClick(scope.row, '已拒绝')"-->
<!--                     type="warning"-->
<!--                     size="small">拒绝</el-button>-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--    </el-table>-->
<!--  </div>-->
<!--</template>-->

<!--<script>-->
<!--export default {-->
<!--  data () {-->
<!--    return {-->
<!--      tableData: [{-->
<!--        name: '管理员',-->
<!--        group: '上海瑞金医院',-->
<!--        gender: '男',-->
<!--        zhicheng: '主任医师',-->
<!--        zhiwu: '科主任',-->
<!--        role: '医院管理员,登记医生',-->
<!--        status: '已通过',-->
<!--      }, {-->
<!--        name: '张医生',-->
<!--        group: '上海瑞金医院',-->
<!--        gender: '男',-->
<!--        zhicheng: '主任医师',-->
<!--        zhiwu: '科主任',-->
<!--        role: '医院管理员,登记医生',-->
<!--        status: '已通过',-->
<!--      }, {-->
<!--        name: '吕医生',-->
<!--        group: '上海瑞金医院',-->
<!--        gender: '男',-->
<!--        zhicheng: '主任医师',-->
<!--        zhiwu: '科主任',-->
<!--        role: '医院管理员,登记医生',-->
<!--        status: '已拒绝',-->
<!--      }, {-->
<!--        name: '王医生',-->
<!--        group: '上海瑞金医院',-->
<!--        gender: '男',-->
<!--        zhicheng: '主任医师',-->
<!--        zhiwu: '科主任',-->
<!--        role: '医院管理员,登记医生',-->
<!--        status: '已通过',-->
<!--      }]-->
<!--    }-->
<!--  },-->
<!--  methods: {-->
<!--    handleClick (item, status) {-->
<!--      item.status = status-->
<!--    }-->
<!--  }-->
<!--}-->
<!--</script>-->
<template>
    <div>
        <el-card>
            <!-- <el-form :model="formInline" :inline="true" ref="formInline" v-if="senior"> -->
            <el-form :inline="true"
                     :model="formInline"
                     ref="formInline"
                     :class="senior?'':'demo-form-inline'"
            >
                <el-form-item label="诊断分型"
                              :style="senior?'margin-left:8%;':''"
                              prop="zhenduanfenxing">
                    <el-cascader :options="zhenduanfenxing_list"
                                 v-model="formInline.zhenduanfenxing"
                                 :style="senior ? 'width: 330px': 'width:400px'">
                    </el-cascader>
                </el-form-item>
                <el-form-item>
                    <el-date-picker v-model="formInline.daterange"
                                    style="float: right; padding: 3px 10px"
                                    type="daterange"
                                    value-format="yyyy-MM-dd"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item v-if="!senior">
                    <el-button @click="onSubmit()"
                               type="primary">查询
                    </el-button>
                    <el-button @click="onReset">重置</el-button>
                    <el-button @click="hLower" :class="senior  ? 'el-icon-arrow-up' : 'el-icon-arrow-down'">
                        高级搜索
                    </el-button>
                </el-form-item>
                <el-form-item v-if="senior" :style="senior?'margin-left:8%;':''">
                    <el-row v-for="(item,index) in formInline.powerAttrList" :key="index" class="demo-form">
                        <el-form-item
                            v-if='index==0 && formInline.daterange.length==0 && formInline.zhenduanfenxing.length==0'
                            style="width:100px"
                        >
                            <el-select placeholder="" v-model="item.condition"
                                       disabled
                            >
                                <el-option label="并且" value="AND"></el-option>
                                <el-option label="或者" value="OR"></el-option>
                                <el-option label="不含" value="NOT"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            v-else
                            style="width:100px"
                            :prop="'powerAttrList.' + index + '.condition'"
                            :rules="[{ required: true, message: '不能为空',trigger: 'change'}]">
                            <el-select placeholder="" v-model="item.condition">
                                <el-option label="并且" value="AND"></el-option>
                                <el-option label="或者" value="OR"></el-option>
                                <el-option label="不含" value="NOT"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            style="width:140px"
                            :prop="'powerAttrList.' + index + '.field'"
                            :rules="[{ required: true, message: '不能为空',trigger: 'change'}]"
                        >
                            <el-select placeholder="字段" v-model="item.field" @change="handleValue(index)">
                                <el-option
                                    v-for="tem in jibenxinxi"
                                    :key="tem.value"
                                    :label="tem.label"
                                    :value="tem.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item v-if="item.field == 'nianling'">
                            <el-select placeholder="" v-model="item.symbol" style="width:100px">
                                <el-option label="等于" value="="></el-option>
                                <el-option label="大于" value=">"></el-option>
                                <el-option label="小于" value="<"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            :prop="'powerAttrList.' + index + '.value'" class="xiala"
                            :rules="[{ required: true, message: '不能为空',trigger: 'change'}]">
                            <el-select placeholder="性别" style="width: 500px;"
                                       v-model="item.value" v-if="item.field=='xingbie'">
                                <el-option label="男" value="男"></el-option>
                                <el-option label="女" value="女"></el-option>
                            </el-select>
                            <el-select placeholder="婚姻状况" style="width:500px"
                                       v-model="item.value" v-else-if="item.field=='hunyin'">
                                <el-option label="已婚" value="已婚"></el-option>
                                <el-option label="未婚" value="未婚"></el-option>
                                <el-option label="离异" value="离异"></el-option>
                                <el-option label="丧偶" value="丧偶"></el-option>
                            </el-select>
                            <el-select v-else-if="item.field == 'weiwanzhengshuju'" style="width:500px"
                                       v-model="item.value">
                                <el-option v-for="item in sectionlist" :key="item.value" :label="item.label"
                                           :value="item.value">
                                </el-option>
                            </el-select>
                            <el-select placeholder="名族" style="width:500px"
                                       v-model="item.value" v-else-if="item.field == 'minzu'">
                                <el-option v-for="item in minzu" :key="item.value" :label="item.label"
                                           :value="item.value">
                                </el-option>
                            </el-select>
                            <el-select placeholder="治疗方案" style="width:500px"
                                       v-model="item.value" v-else-if="item.field == 'zhiliaoxinxi'">
                                <el-option v-for="item in zhiliaoxinxi" :label="item.label" :value="item.value"
                                           :key="item.value">
                                </el-option>
                            </el-select>
                            <el-cascader style="width:500px" v-model="item.value" :options="zhuanguifeiyong" filterable
                                         v-else-if="item.field == 'zhuanguifeiyong'">
                            </el-cascader>
                            <el-cascader style="width:500px" v-model="item.value" :options="xibaoyichuan" filterable
                                         v-else-if="item.field == 'xibaoyichuan'">
                            </el-cascader>
                            <el-cascader style="width:390px" v-model="item.value" :options="fenzibiaozhi" filterable
                                         v-else-if="item.field == 'fenzibiaozhi'">
                            </el-cascader>
                            <el-cascader v-model="item.value" :options="mianyibiaoxing" filterable
                                         v-else-if="item.field == 'mianyibiaoxing'" style="width:280px">
                            </el-cascader>
                            <el-cascader v-model="item.value" :options="city" filterable v-else-if="item.field=='huji'"
                                         style="width:500px">
                            </el-cascader>
                            <el-cascader v-model="item.value" :options="linchuangxinxi" filterable
                                         v-else-if="item.field == 'linchuangxinxi'" style="width:280px">
                            </el-cascader>
                            <el-cascader :options="zhenduanfenxing_list" style="width:500px"
                                         v-model="item.value" v-else-if="item.field =='zhenduanfenxing'"
                            >
                            </el-cascader>
                            <el-input v-model="item.value" style="width:390px" placeholder="请输入"
                                      v-else-if="item.field=='nianling'"></el-input>
                            <el-input v-model="item.value" style="width:500px" placeholder="请输入" v-else></el-input>
                        </el-form-item>
                        <el-form-item v-if="item.field == 'fenzibiaozhi'">
                            <el-select placeholder="" v-model="item.inputvalue" style="width:100px">
                                <el-option label="阴性" value="阴性"></el-option>
                                <el-option label="阳性" value="阳性"></el-option>
                                <el-option label="未作" value="未作"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item v-if="item.field == 'linchuangxinxi' || item.field =='mianyibiaoxing'">
                            <el-select placeholder="" v-model="item.symbol" style="width:100px">
                                <el-option label="等于" value="="></el-option>
                                <el-option label="大于" value=">"></el-option>
                                <el-option label="小于" value="<"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item v-if="item.field == 'linchuangxinxi' || item.field =='mianyibiaoxing'">
                            <el-input v-model="item.inputvalue" style="width:100px" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button v-if="formInline.powerAttrList.length > 1" @click="removeRow(index)" type="text"
                                       style="font-size:20px;padding:5px 0px;">
                                <i class="el-icon-remove-outline"></i>
                            </el-button>
                            <el-button v-if="index===formInline.powerAttrList.length-1"
                                       @click="addRow"
                                       type="text"
                                       style="font-size:20px;padding:5px 0px;">
                                <i class="el-icon-circle-plus-outline"></i>
                            </el-button>
                        </el-form-item>
                        <el-form-item v-if="index===formInline.powerAttrList.length-1">
                            <el-button @click="onSubmit()"
                                       type="primary">查询
                            </el-button>
                            <el-button @click="onReset">重置</el-button>
                            <el-button @click="hLower" :class="senior  ? 'el-icon-arrow-up' : 'el-icon-arrow-down'">
                                高级搜索
                            </el-button>

                        </el-form-item>
                    </el-row>
                </el-form-item>
            </el-form>
            <el-table :data="tableData"
                      v-loading="loading"
                      stripe
                      class="table"
                      style="width: 100%">
                <el-table-column type="index"
                                 label="序号"
                                 header-align="center"
                                 width="70"
                                 align="center">
                    <template slot-scope="scope">
                        <span>{{ (currentPage - 1) * pageSize + scope.$index + 1 }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="ID"
                >
                    <template slot-scope="scope">
                        <el-button @click="handlepk(scope.row)"
                                   size="small"
                                   type="text">{{ scope.row.pk }}
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="status"
                                 label="审核状态"
                >
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.status=='0'" type="danger">{{ scope.row.statusName }}</el-tag>
                        <el-tag v-else-if="scope.row.status=='1'" type="success">{{ scope.row.statusName }}</el-tag>
                        <el-tag v-else-if="scope.row.status=='2'" type="warning">{{ scope.row.statusName }}</el-tag>
                        <el-tag v-else type="info">{{ scope.row.statusName }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="shengcunzhuangtai"
                                 label="状态"

                >
                    <template slot-scope="scope">
                        <el-tag :class="scope.row.shengcunzhuangtaitag" :id="scope.row.gengxinb"
                                v-if="scope.row.shengcunzhuangtai != '死亡' && scope.row.gengxin === 2 || scope.row.shengcunzhuangtaitag"
                                disable-transitions>
                            <span v-if="scope.row.shengcunzhuangtaitag === 'red'">{{ scope.row.bingli }}待更新</span>
                            <span v-else>{{ scope.row.bingli }}待随访</span>
                        </el-tag>
                        <el-tag :class="scope.row.shengcunzhuangtai === '死亡' ? 'primary' : 'info'" v-else
                                disable-transitions>{{ scope.row.bingli }}{{ scope.row.shengcunzhuangtai }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="xingming"
                                 label="患者姓名"
                >
                </el-table-column>
                <el-table-column prop="nianling"
                                 label="患者年龄"
                >
                </el-table-column>
                <el-table-column prop="zhenduanfenxing"
                                 show-overflow-tooltip

                                 label="诊断分型">
                </el-table-column>
                <el-table-column show-overflow-tooltip
                                 prop="yiyuan"

                                 label="医院">
                </el-table-column>
                <el-table-column prop="created"
                                 label="录入时间"
                >
                </el-table-column>
                <el-table-column label="病例完成度"
                                 width="180">
                    <template slot-scope="scope">
                        <el-tooltip class="item" content="基本信息模块未填写" placement="top" v-if="scope.row.jibenxinxi == 0">
                            <img src="../../assets/images/0.png" class="user-avatar"/>
                        </el-tooltip>
                        <el-tooltip class="item" content="基本信息模块已完整" placement="top"
                                    v-else-if="scope.row.jibenxinxi == 1">
                            <img src="../../assets/images/1.png" class="user-avatar "/>
                        </el-tooltip>
                        <el-tooltip class="item" content="基本信息模块已填写" placement="top" v-else>
                            <img src="../../assets/images/2.png" class="user-avatar "/>
                        </el-tooltip>
                        <el-tooltip class="item" content="临床信息模块未填写" placement="top"
                                    v-if="scope.row.linchuangxinxi == 0">
                            <img src="../../assets/images/0.png" class="user-avatar "/>
                        </el-tooltip>
                        <el-tooltip class="item" content="临床信息模块已完整" placement="top"
                                    v-else-if="scope.row.linchuangxinxi == 1">
                            <img src="../../assets/images/1.png" class="user-avatar "/>
                        </el-tooltip>
                        <el-tooltip class="item" content="临床信息模块已填写" placement="top" v-else>
                            <img src="../../assets/images/2.png" class="user-avatar "/>
                        </el-tooltip>
                        <el-tooltip class="item" content="细胞遗传模块未填写" placement="top" v-if="scope.row.xibaoyichuan == 0">
                            <img src="../../assets/images/0.png" class="user-avatar "/>
                        </el-tooltip>
                        <el-tooltip class="item" content="细胞遗传模块已完整" placement="top"
                                    v-else-if="scope.row.xibaoyichuan == 1">
                            <img src="../../assets/images/1.png" class="user-avatar "/>
                        </el-tooltip>
                        <el-tooltip class="item" content="细胞遗传模块已填写" placement="top" v-else>
                            <img src="../../assets/images/2.png" class="user-avatar "/>
                        </el-tooltip>
                        <el-tooltip class="item" content="分子标志模块未填写" placement="top" v-if="scope.row.fenzibiaozhi == 0">
                            <img src="../../assets/images/0.png" class="user-avatar "/>
                        </el-tooltip>
                        <el-tooltip class="item" content="分子标志模块已完整" placement="top"
                                    v-else-if="scope.row.fenzibiaozhi == 1">
                            <img src="../../assets/images/1.png" class="user-avatar "/>
                        </el-tooltip>
                        <el-tooltip class="item" content="分子标志模块已填写" placement="top" v-else>
                            <img src="../../assets/images/2.png" class="user-avatar "/>
                        </el-tooltip>
                        <el-tooltip class="item" content="免疫细胞模块未填写" placement="top"
                                    v-if="scope.row.mianyibiaoxing == 0">
                            <img src="../../assets/images/0.png" class="user-avatar "/>
                        </el-tooltip>
                        <el-tooltip class="item" content="免疫细胞模块已完整" placement="top"
                                    v-else-if="scope.row.mianyibiaoxing == 1">
                            <img src="../../assets/images/1.png" class="user-avatar "/>
                        </el-tooltip>
                        <el-tooltip class="item" content="免疫细胞模块已填写" placement="top" v-else>
                            <img src="../../assets/images/2.png" class="user-avatar "/>
                        </el-tooltip>
                        <el-tooltip class="item" content="治疗信息模块未填写" placement="top" v-if="scope.row.zhiliaoxinxi == 0">
                            <img src="../../assets/images/0.png" class="user-avatar "
                                 v-if="scope.row.zhiliaoxinxi == 0"/>
                        </el-tooltip>
                        <el-tooltip class="item" content="治疗信息模块已完整" placement="top"
                                    v-else-if="scope.row.zhiliaoxinxi == 1">
                            <img src="../../assets/images/1.png" class="user-avatar "/>
                        </el-tooltip>
                        <el-tooltip class="item" content="治疗信息模块已填写" placement="top" v-else>
                            <img src="../../assets/images/2.png" class="user-avatar "/>
                        </el-tooltip>
                        <el-tooltip class="item" content="转归费用模块未填写" placement="top"
                                    v-if="scope.row.zhuanguifeiyong == 0">
                            <img src="../../assets/images/0.png" class="user-avatar "/>
                        </el-tooltip>
                        <el-tooltip class="item" content="转归费用模块已完整" placement="top" v-else>
                            <img src="../../assets/images/1.png" class="user-avatar "/>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column label="未完成项"
                                 show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        <span>{{ scope.row.weiwanchen | textfilter }}</span>
                    </template>
                </el-table-column>
                <el-table-column fixed="right"
                                 label="操作"
                                 width="150px">
                    <template slot-scope="scope">
                        <el-button @click="handleApprover(scope.row, '1')"
                                   type="success"
                                   size="small">通过
                        </el-button>
                        <el-button @click="handleApprover(scope.row, '3')"
                                   type="warning"
                                   size="small">拒绝
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div style="margin-top: 30px;text-align: center">
                <el-pagination :current-page="currentPage"
                               :page-size="pageSize"
                               :page-sizes="[10, 20, 30, 50, 100]"
                               :total="totalData"
                               @current-change="handleCurrentChange"
                               @size-change="handleSizeChange"
                               layout="total, sizes, prev, pager, next, jumper"></el-pagination>
            </div>
        </el-card>
        <el-dialog
            title="审核"
            :visible.sync="dialogVisible"
            width="40%"
        >
            <el-form :model="form" :rules="rules" ref="form">
                <el-form-item label="意见" label-width="120px" >
                    <el-input v-model="form.opinion" style="width:80%" type="textarea"
                              :autosize="{ minRows: 10, maxRows: 10}"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="handleClick">确 定</el-button>
              </span>
        </el-dialog>
        <el-dialog
            title="详情"
            :visible.sync="models2"
            width="90%"
        >
            <Addmodel ref="addform"/>
            <!-- <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="models2 = false">确 定</el-button>
            </span> -->
        </el-dialog>
    </div>
</template>

<script>
import * as table from '../../config/cyit'
import zhenduanfenxing_list from '../../config/zhenduanfenxing'
import {setTimeout} from 'timers';
import Addmodel from '../case/add'

export default {
    components: {
        Addmodel,
    },
    data() {
        return {
            is_admin: false,
            models2: false,
            model1: false,
            groupList: [],
            userList: [],
            quanxianform: {
                user: [],
                group: [],
                pk: [],
            },
            tag: '',
            setmodel: false,
            dynamicTags: [],
            inputVisible: false,
            inputValue: '',
            dialogVisible: false,
            loading: true,
            city: table.citys,
            minzu: table.minzu,
            sectionlist: table.sectionlist,
            mianyibiaoxing: table.mianyibiaoxing,
            xibaoyichuan: table.xibaoyichuan,
            linchuangxinxi: table.linchuangxinxi,
            zhenduanfenxing_list: zhenduanfenxing_list,
            zhiliaoxinxi: table.zhiliaoxinxi,
            jibenxinxi: table.jibenxinxi,
            zhuanguifeiyong: table.zhuanguifeiyong,
            fenzibiaozhi: table.fenzibiaozhi,
            currentPage: 1,
            pageSize: 20,
            totalData: 0,
            pk: 0,
            form: {
                opinion: '',
                status:null,
                pk:null
            },
            tableData: [],
            formInline: {
                zhenduanfenxing: [],
                daterange: [],
                powerAttrList: [{
                    symbol: '',
                    field: '',
                    value: '',
                    inputvalue: '',
                    condition: '',
                }],
            },
            senior: false,
            rules: {
                name: [
                    {required: true, message: '请输入名称', trigger: 'blur'},
                ],
            }
        }
    },
    filters: {
        textfilter(value) {
            var temp = []
            var dictwwcx = {
                "jibenxinxi": "基本信息",
                "linchuangxinxi": "临床信息",
                "xibaoyichuan": "细胞遗传",
                "fenzibiaozhi": "分子标志",
                "mianyibiaoxing": "免疫表型",
                "zhiliaoxinxi": "治疗信息",
            }
            for (var i = 0; i < value.length; i++) {
                temp.push(dictwwcx[value[i]])
            }
            return temp
        }
    },
    methods: {
        handlepk(row) {
            this.models2 = true
            setTimeout(function () {
                this.$refs.addform.getData(row.pk, 'edit')
            }.bind(this), 400)
        },
        handleValue(index) {
            this.formInline.powerAttrList[index].value = ''
        },
        hLower() {
            this.senior = !this.senior;
            this.onReset();
        },
        addRow() {
            this.formInline.powerAttrList.push({
                symbol: '',
                field: '',
                value: '',
                inputvalue: '',
                condition: '',
            });
        },
        removeRow(index) {
            this.formInline.powerAttrList.splice(index, 1);
        },
        onSubmit() {
            if (this.senior) {
                this.$refs['formInline'].validate((valid) => {
                    if (valid) {
                        this.search()
                    }
                })
            } else {
                this.getData()
            }
        },
        onReset() {
            this.setmodel = false
            this.tag = ''
            this.$refs['formInline'].resetFields()
            this.formInline.powerAttrList = [{
                symbol: '',
                field: '',
                value: '',
                inputvalue: '',
                condition: '',
            }]
            this.formInline.zhenduanfenxing = []
            this.formInline.daterange = []
            this.currentPage = 1

            this.getData()
        },
        handleApprover(row,status){
            this.form.status = status
            this.form.pk = row.pk
            this.dialogVisible = true
        },
        handleClick() {
            this.$http.post(`/case/status/`, this.form)
                .then(resp => {
                        if (resp.data.code == 1) {
                            this.$message({
                                message: '提交成功！',
                                type: 'success'
                            })
                            this.dialogVisible = false
                            this.getData()
                        } else {
                            this.$message({
                                message: resp.data.msg,
                                type: 'error'
                            })
                        }
                    }
                )
        },
        handleSizeChange(val) {
            this.currentPage = 1
            this.pageSize = val
            if (this.setmodel) {
                this.handClick()
            } else {
                if (this.formInline.powerAttrList[0].field) {
                    this.search()
                } else {
                    this.getData()
                }
            }
        },
        handleCurrentChange(val) {
            // console.log(`当前页: ${val}`)
            this.currentPage = val
            if (this.setmodel) {
                this.handClick()
            } else {
                if (this.formInline.powerAttrList[0].field) {
                    this.search()
                } else {
                    this.getData()
                }
            }
        },
        search() {
            this.loading = true
            this.setmodel = false
            this.tag = ''
            this.formInline['page'] = this.currentPage
            this.formInline['pageSize'] = this.pageSize
            this.formInline['keywords'] = (this.formInline.zhenduanfenxing.length == 2 ? this.formInline.zhenduanfenxing[1] : this.formInline.zhenduanfenxing[0]) || ''
            this.formInline['start'] = this.formInline.daterange[0] || ''
            this.formInline['end'] = this.formInline.daterange[1] || ''
            this.formInline['approval'] = "approval"
            this.$http.post('/case/search/list/', this.formInline)
                .then(resp => {
                    this.tableData = resp.data.data
                    this.totalData = resp.data.total
                    this.form.case = resp.data.datapk
                    this.dynamicTags = resp.data.jihe_list
                    this.loading = false
                })
                .catch((err) => {
                    console.log(err)
                    this.loading = false
                })
        },

        getData() {
            this.loading = true
            this.setmodel = false
            this.tag = ''
            var gengxin = this.$route.query.data || ''
            // setTimeout(function () {
            var keywords = (this.formInline.zhenduanfenxing.length == 2 ? this.formInline.zhenduanfenxing[1] : this.formInline.zhenduanfenxing[0]) || ''
            var start = this.formInline.daterange[0] || ''
            var end = this.formInline.daterange[1] || ''
            this.$http.get(`/case/list/?page=${this.currentPage}&pageSize=${this.pageSize}&keywords=${keywords}&start=${start}&end=${end}&gengxin=${gengxin}&approval=approval`)
                .then(resp => {
                    this.tableData = resp.data.data
                    this.totalData = resp.data.total
                    this.dynamicTags = resp.data.jihe_list
                    this.form.case = resp.data.datapk
                    this.loading = false
                })
                .catch((err) => {
                    console.log(err)
                    this.loading = false
                })
            // }.bind(this), 400)
        }
    },
    mounted() {
        let is_admin = localStorage.getItem('is_admin')
        if (is_admin != 'false') {
            this.is_admin = true
        }
        this.getData()
    }
};
</script>

<style scoped>
/deep/ .dynamicTags .el-radio__input {
    display: none;
}

/deep/ .el-radio__label {
    font-size: 14px;
    padding-left: 5px;
}

.el-radio {
    margin-right: 0px;
}

.el-tag + .el-tag {
    margin-left: 10px;
}

.el-tag--mini {
    height: 28px;
    padding: 0 10px;
    line-height: 27px;

}

.button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
}

.input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
}

/*.xiala /deep/ .el-input--mini .el-input__inner {
  width: 500px;
}*/
.primary {
    background-color: #909399;
    border-color: #909399;
    color: white;
}

.info {
    background-color: #e4e4e4;
    border-color: #e4e4e4;
    color: #909399;
}

#warning {
    display: inline-block;
    background: #e6a23c;
    color: white;
}

.warning {
    display: inline-block;
    background: #e6a23c;
    color: white;
}

.red {
    display: inline-block;
    background: #f56c6c;
    color: white;
}

.table /deep/ .el-tag--mini {
    width: 80%;
    height: 20px;
    padding: 0 5px;
    line-height: 19px;
    text-align: center;
    border-color: transparent;
}

.demo-form-inline {
    text-align: right;
}

.demo-form {
    /*margin-left: 30px;*/
}

.demo-form /deep/ .el-form-item.is-success .el-input__inner {
    border-color: none;
}

.demo-form /deep/ .el-input--medium .el-input__inner {
    height: 25px;
    line-height: 25px;
}

.demo-form /deep/ .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
    margin-bottom: 8px;
}

.user-avatar {
    width: 20px;
    height: 20px;
    /*border-radius: 10px;*/
    vertical-align: middle;
}
</style>
